// extracted by mini-css-extract-plugin
module.exports = {"bgColor":"hsl(137, 41%, 90%)","primary":"#A44338","yellow":"#fed011","puke":"#5e5d2d","teal":"#0d6d6e","redOrange":"#e64f2a","black":"#384201"};